import Box from 'components/shared/Box'
import { AccommodationInfoAsideBox } from './styles'
import { useResolutions } from 'store/resolutions'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Link from 'components/shared/Link'
import IconWithText from 'components/shared/IconWithText'
import ExpandableBox from 'components/shared/ExpandableBox'
import { useAppDispatch } from 'store/hooks'
import { setAccommodationInfoModalVisible } from 'store/accommodation-slice'

import iconGrill from 'assets/icons/grill.svg'
import iconRestaurant from 'assets/icons/restaurant.svg'
import iconDiscount from 'assets/icons/promotion-discount.svg'
import iconMap from 'assets/icons/map.svg'
import SuntagoVillageLogo from 'assets/images/logos/Suntago_Village.svg'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'

const AccommodationInfoAside = () => {
    const { formatMessage } = useIntl()
    const { isTablet } = useResolutions()
    const dispatch = useAppDispatch()
    const { isCityBreakPromoActive } = usePromotions()

    const [isExpandableBoxOpen, setIsExpandableBoxOpen] = useState(false)

    const handleOpenInfoModal = () =>
        dispatch(setAccommodationInfoModalVisible(true))

    const ExpandableContent = (
        <Box gap={[24, 32]}>
            <Box direction="column" isFullWidth gap={24}>
                <IconWithText
                    icon={iconDiscount}
                    iconAlt="Discount Icon"
                    gap={12}
                    fontVariant="bodySmall"
                    textHighlighted={
                        isCityBreakPromoActive
                            ? formatMessage({
                                  id: 'accommodation.teaser.city_break_discounts',
                                  defaultMessage: '_',
                              })
                            : formatMessage({
                                  id: 'accommodation.teaser.advantage_discounts',
                                  defaultMessage: '_',
                              })
                    }
                />
                <IconWithText
                    icon={iconGrill}
                    iconAlt="Grill Icon"
                    gap={12}
                    fontVariant="bodySmall"
                    textHighlighted={formatMessage({
                        id: 'accommodation.teaser.advantage_entertainment',
                        defaultMessage: 'Otwarte strefy i place zabaw',
                    })}
                />
                <IconWithText
                    icon={iconRestaurant}
                    iconAlt="Restaurant Icon"
                    gap={12}
                    fontVariant="bodySmall"
                    textHighlighted={formatMessage({
                        id: 'accommodation.teaser.advantage_services',
                        defaultMessage:
                            'Dodatkowe usługi, które umilą Twój pobyt',
                    })}
                />
                <IconWithText
                    icon={iconMap}
                    iconAlt="Map Icon"
                    gap={12}
                    fontVariant="bodySmall"
                    textHighlighted={
                        <FormattedMessage
                            id="accommodation.teaser.advantage_location_v2"
                            defaultMessage="Dogodna lokalizacja <span>5 min.</span> od parku Suntago"
                            values={{
                                span: (chunks: string[]) => (
                                    <span className="no-wrap">{chunks}</span>
                                ),
                            }}
                        />
                    }
                />
            </Box>
            <Link
                variant="secondary"
                textVariant="bodySmallStrong"
                onClick={handleOpenInfoModal}
                data-testid="accommo-info-button-learn-more"
            >
                {isTablet ? (
                    <FormattedMessage
                        id="global.btn.read_more"
                        defaultMessage="Dowiedz się więcej"
                    />
                ) : (
                    <FormattedMessage
                        id="accommodation.teaser.know_suntago_link"
                        defaultMessage="Poznaj Suntago Village"
                    />
                )}
            </Link>
        </Box>
    )

    return (
        <AccommodationInfoAsideBox mt={[16, 74]} gap={32}>
            {!isTablet && (
                <>
                    <Box isFullWidth align={['flex-start', 'center']}>
                        <img src={SuntagoVillageLogo} alt="Suntago Village" />
                    </Box>
                    {ExpandableContent}
                </>
            )}
            {isTablet && (
                <ExpandableBox
                    icon={
                        <img
                            width={68}
                            src={SuntagoVillageLogo}
                            alt="Suntago Village"
                        />
                    }
                    iconTitle={
                        <FormattedMessage
                            id="accommodation.teaser.know_suntago_header"
                            defaultMessage="Poznaj <span>Suntago Village</span>"
                            values={{
                                span: (chunks: string[]) => (
                                    <>
                                        <br />
                                        {chunks}
                                    </>
                                ),
                            }}
                        />
                    }
                    color="primary_500"
                    iconTitleColor="grayscale_900"
                    isBoxOpen={isExpandableBoxOpen}
                    setIsBoxOpen={setIsExpandableBoxOpen}
                >
                    {ExpandableContent}
                </ExpandableBox>
            )}
        </AccommodationInfoAsideBox>
    )
}

export default AccommodationInfoAside
